import { FunctionComponent } from "react";
import IconButton from "../iconButton/IconButton";
import "./Search.css"

interface SearchProps {
    onChangeValue?: (value: string) => void,
    value?: string
}
 
const Search: FunctionComponent<SearchProps> = (props) => {
    let {value, onChangeValue} = props;

    return (  
        <div className="search-input">
            <IconButton tooltipText="Search" type="search"/>
            <input className="" placeholder="Search" type="text" value={value} onChange={ e => {onChangeValue && onChangeValue(e.target.value)}} />
        </div>
    );
}
 
export default Search;